// File: src/components/common/Footer.jsx
// Description: Simplified footer with clean list-style contact design

import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { CONTACT_INFO } from '../../utils/constants';

const Footer = () => {
  const { getText, currentLanguage, LANGUAGES } = useLanguage();

  return (
    <footer className="footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            
            {/* University Info Section (Left Column) */}
            <div className="footer-section university-info">
              <div className="footer-logo">
                <img 
                  src="/logo.png" 
                  alt="Mahavihara University Logo"
                  className="logo-image"
                />
                <div className="logo-text">
                  <h3 className={`university-name ${currentLanguage === LANGUAGES.MM ? "myanmar-text" : ""}`}>
                    {getText({ 
                      [LANGUAGES.EN]: 'Mahavihara', 
                      [LANGUAGES.MM]: 'မဟာဝိဟာရ' 
                    })}
                  </h3>
                  <p className={`university-subtitle ${currentLanguage === LANGUAGES.MM ? "myanmar-text" : ""}`}>
                    {getText({ 
                      [LANGUAGES.EN]: 'Dhamma Vinaya University', 
                      [LANGUAGES.MM]: 'ဓမ္မဝိနယ တက္ကသိုလ်' 
                    })}
                  </p>
                </div>
              </div>
              <p className={`university-description ${currentLanguage === LANGUAGES.MM ? "myanmar-text" : ""}`}>
                {getText({
                  [LANGUAGES.EN]: 'ဤတက္ကသိုလ်သည် နေနည်းရှေးကျ သင်နည်းခေတ်မီ ဟူသော ရှေးမထေရ်မြတ်တို့၏ ဩဝါဒဖြင့် တည်ထောင်အပ်သော ဗုဒ္ဓတက္ကသိုလ်ဖြစ်ပါသည်။ ဤတက္ကသိုလ်၌ ယခုနှစ်တွင် အကြိုဒီပလိုမာသင်တန်း၊ ဘွဲ့ကြိုဒီပလိုမာသင်တန်း၊ ဘီအေ(ဓမ္မဝိနယ) သင်တန်း၊ ဘွဲ့လွန် ဒီပလိုမာ (ပါဠိ/သက္ကတ) သင်တန်း၊ မဟာဝိဇ္ဇာ(ဓမ္မဝိနယ) သင်တန်း၊ မဟာဝိဇ္ဇာ(ပါဠိ/သက္က) သင်တန်း၊ တက္ကသီလဓမ္မာစရိယ သင်တန်း၊ စုစုပေါင်း သင်တန်း ၇ ခု ဖွင့်လှစ်လျက်ရှိပါသည်။',
                  [LANGUAGES.MM]: 'ဤတက္ကသိုလ်သည် နေနည်းရှေးကျ သင်နည်းခေတ်မီ ဟူသော ရှေးမထေရ်မြတ်တို့၏ ဩဝါဒဖြင့် တည်ထောင်အပ်သော ဗုဒ္ဓတက္ကသိုလ်ဖြစ်ပါသည်။ ဤတက္ကသိုလ်၌ ယခုနှစ်တွင် အကြိုဒီပလိုမာသင်တန်း၊ ဘွဲ့ကြိုဒီပလိုမာသင်တန်း၊ ဘီအေ(ဓမ္မဝိနယ) သင်တန်း၊ ဘွဲ့လွန် ဒီပလိုမာ (ပါဠိ/သက္ကတ) သင်တန်း၊ မဟာဝိဇ္ဇာ(ဓမ္မဝိနယ) သင်တန်း၊ မဟာဝိဇ္ဇာ(ပါဠိ/သက္က) သင်တန်း၊ တက္ကသီလဓမ္မာစရိယ သင်တန်း၊ စုစုပေါင်း သင်တန်း ၇ ခု ဖွင့်လှစ်လျက်ရှိပါသည်။'
                })}
              </p>
            </div>

            {/* Contact Info Section removed as per request */}
            {/* Map Section (Right Column) */}
            <div className="footer-section map-section">
              <h4 className={`footer-title ${currentLanguage === LANGUAGES.MM ? "myanmar-text" : ""}`}>
                {getText({ 
                  [LANGUAGES.EN]: 'Our Location', 
                  [LANGUAGES.MM]: 'ကျွန်ုပ်တို့၏တည်နေရာ' 
                })}
              </h4>
              <div className="footer-map">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3514.5991252834024!2d96.0912814747836!3d17.148477483698567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30c19f783804f291%3A0xd1fa283c58d07837!2sMahavihara%20Dhammavinaya%20University!5e1!3m2!1sen!2smm!4v1756451497299!5m2!1sen!2smm" 
                  style={{ border: 0 }} 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="University Location Map"
                ></iframe>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className={`copyright ${currentLanguage === LANGUAGES.MM ? "myanmar-text" : ""}`}>
              © {new Date().getFullYear()} {getText({
                [LANGUAGES.EN]: 'Mahavihara Dhamma Vinaya University. All rights reserved. Developed by Studivert',
                [LANGUAGES.MM]: 'မဟာဝိဟာရ ဓမ္မဝိနယ တက္ကသိုလ်။ မူပိုင်ခွင့်အားလုံး ရယူထားသည်။ Developed by Studivert'
              })}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;